import { GetServerSideProps } from 'next';

const CreatorPage = () => {
  return <></>;
};

export const getServerSideProps: GetServerSideProps = async () => {
  // currently with removing of discover we want to redirect to home
  return {
    redirect: {
      permanent: true,
      destination: `/`,
    },
  };
};
export default CreatorPage;
